import { render, staticRenderFns } from "./ListaEnvios.vue?vue&type=template&id=d0a9af78&scoped=true&"
import script from "./ListaEnvios.vue?vue&type=script&lang=js&"
export * from "./ListaEnvios.vue?vue&type=script&lang=js&"
import style0 from "./ListaEnvios.vue?vue&type=style&index=0&id=d0a9af78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a9af78",
  null
  
)

export default component.exports